export default __webpack_public_path__ + "static/media/KH.9fed9b2d.svg";